import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: '[tdWbTableCardColumnTemplate]'
})
export class TableCardColumnTemplateDirective {
  readonly templateRef: TemplateRef<unknown> = inject(TemplateRef)
}
